// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3159":"954c0f786d0e4640","5673":"954c0f786d0e4640"}[chunkId] + ".css";
};